import Loading from '../loading/Loading.jsx';
import MergedTableHeader from './MergedTableHeader.jsx';
import Pagination from './Pagination.jsx';

import '../../../css/data-grid.css';
import { useDynamicStyle } from '../../../hooks/useDynamicStyle.js';
import * as Icons from '../../../images/icons/icons_component.js';
import * as Theme from '../../../images/icons/icons_theme';
import { useSubIcon } from '../../../hooks/useSubIcon.js';

const ShowDetailDataGrid = ({ propsInfo, state, pageInfo, setPageInfo, mergeConfig, popupPropsInfo, searchParams }) => {

    const dataList = state.dataList;
    const isSearched = state.isSearched;
    const isLoading = state.isLoading;

    const dataHead = propsInfo.dataHead;
    const dataColumn = propsInfo.dataColumn;
    const excelHead = propsInfo.excelHead;
    const colWidth = propsInfo.colWidth;
    const tdWrap = propsInfo.wrapTF;

    const paginationTF = pageInfo.paginationTF;

    const onHandlePage = (page) => {
        if (page !== pageInfo.currentPage) {
            setPageInfo(prev => ({
                ...prev,
                currentPage: page
            }));
        }
    };
    const paginationInfo = {
        ...pageInfo,
        onPageChange: onHandlePage,
    }

    const computeRowSpans = (dataList, mergeConfig = [], allColumns = []) => {
        const rowSpans = dataList.map(() => ({}));

        // 병합 대상 컬럼 처리
        mergeConfig.forEach(({ key: colKey, row, nullable }) => {
            let prevValue = null;
            let startIndex = 0;
            let mergeCount = 1;

            for (let i = 0; i < dataList.length; i++) {
                const currentValue = dataList[i][colKey];
                const isMergeable = nullable ? currentValue === prevValue : (currentValue === prevValue && currentValue !== '' && currentValue !== null);
                if (isMergeable) {
                    if (row == null || mergeCount < row) {
                        rowSpans[startIndex][colKey] += 1;
                        rowSpans[i][colKey] = 0;
                        mergeCount += 1;
                    } else {
                        rowSpans[i][colKey] = 1;
                        startIndex = i;
                        mergeCount = 1;
                    }
                } else {
                    rowSpans[i][colKey] = 1;
                    startIndex = i;
                    mergeCount = 1;
                    prevValue = currentValue;
                }
            }
        });
        // 병합 대상이 아닌 컬럼 처리
        dataList.forEach((_, i) => {
            allColumns.forEach(colKey => {
                if (!(colKey in rowSpans[i])) {
                    rowSpans[i][colKey] = 1;
                }
            });
        });

        return rowSpans;
    };

    const rowSpans = computeRowSpans(dataList, mergeConfig ?? [], dataColumn);
    const colSpan = excelHead.length < 1 ? dataHead.length : excelHead.length;

    const { lightBackColor, borderColorGray, hoverLightFontColor } = useDynamicStyle();
    const {SearchIcon} = useSubIcon();

    return (
        <div className='data_grid_container'>
            {isLoading ? <Loading /> :
                <>
                    <hr className={`border-t-2 mr-1-1 ${borderColorGray}`} />
                    <div className={`data_list_table ${tdWrap && 'td_wrap'} ${isSearched ? 'grid-animation' : ''}`}>
                        <table>
                            {colWidth !== undefined &&
                                <colgroup>
                                    {colWidth.length > 0 && colWidth.map((per, idx) => <col key={idx} width={per} /> )}
                                </colgroup>
                            }
                            <MergedTableHeader
                                headers={dataHead}
                            />
                            <tbody>
                                {dataList.length === 0 ? (
                                    <tr>
                                        <td colSpan={1000} className='empty_box'>
                                            <span className={`data_empty ${lightBackColor}`}>
                                                {isSearched ? <Icons.EmptySalgu /> : <Icons.NullSalgu />}
                                                {isSearched ? '해당하는 데이터가 없습니다.' : '검색 버튼을 눌러 데이터를 조회하세요.'}
                                            </span>
                                        </td>
                                    </tr>
                                ) : (
                                    dataList.map((item, rowIndex) => {
                                        const gridColor = rowIndex % 2 === 0 ? lightBackColor : '';
                                        return (
                                        <tr key={rowIndex} className={gridColor}>
                                            {dataColumn.map((col, colIndex) => {
                                                const span = rowSpans[rowIndex][col];
                                                if (!span) return null;

                                                const prefix = col.split('_')[0];
                                                const isClickable = popupPropsInfo.checked.includes(prefix);
                                                if (isClickable) {

                                                }
                                                const handleClick = async () => {
                                                    let popup = null;

                                                    if (isSearched && ["SEQ", "DETAIL"].includes(prefix)) {
                                                        const senData = {
                                                            flag: "update",
                                                            IEM_ID: dataList[rowIndex].IEM_ID,
                                                            DETAIL_SN: dataList[rowIndex].DETAIL_SN,
                                                            ATCH_DTA: encodeURIComponent(dataList[rowIndex].ATCH_DTA),
                                                            searchHosp: searchParams.searchEmog,
                                                            schdulFlag: 'schdul',
                                                            userAuth: localStorage.getItem("userAuth"),
                                                            userEmcd: localStorage.getItem("useremcd"),
                                                            userDesc: localStorage.getItem("emogdesc"),
                                                        }
                                                        localStorage.setItem(popupPropsInfo.localStorageName, JSON.stringify(senData));
                                                        popup = window.open(popupPropsInfo.popupAddress, "팝업", `scrollbars=1, resizable=0, width=${popupPropsInfo.width || '1010'}, height=${popupPropsInfo.height || '745'}, top=30, left=30`);
                                                    } else {
                                                        const ATCH_DTA = dataList[rowIndex].ATCH_DTA;
                                                        const IEM_ID = dataList[rowIndex].IEM_ID;
                                                        const DETAIL_SN = dataList[rowIndex].DETAIL_SN;
                                                        const searchDir = popupPropsInfo.searchDir;

                                                        if (!ATCH_DTA) {
                                                            alert("증빙자료가 없습니다.");
                                                            return;
                                                        }
                                                        const params = new URLSearchParams({
                                                            ATCH_DTA: encodeURIComponent(dataList[rowIndex].ATCH_DTA),
                                                            IEM_ID,
                                                            DETAIL_SN,
                                                            searchDir
                                                        });
                                                        try {
                                                            const response = await fetch(`${popupPropsInfo.downloadURI}?${params.toString()}`, {
                                                                method: "GET",
                                                            });

                                                            if (!response.ok) {
                                                                alert("파일을 찾을 수 없습니다.");
                                                                return;
                                                            }

                                                            const blob = await response.blob();
                                                            const url = window.URL.createObjectURL(blob);

                                                            const a = document.createElement("a");
                                                            a.href = url;
                                                            a.download = ATCH_DTA;
                                                            document.body.appendChild(a);
                                                            a.click();
                                                            a.remove();
                                                            window.URL.revokeObjectURL(url);
                                                        } catch (error) {
                                                            console.error("파일 다운로드 중 오류 발생:", error);
                                                            alert("다운로드에 실패했습니다.");
                                                        }
                                                    }
                                                };

                                                const cellStyle = (dataList[rowIndex].TRMSEMCD === 'A00' ? 'bold ' : '')
                                                    + (isClickable ? `cursor-pointer ${(prefix === "SEQ" || prefix === "DETAIL") ? 'h_icon_box' : 'underline'} ${hoverLightFontColor}` : '');

                                                return (
                                                    <td
                                                        key={colIndex}
                                                        rowSpan={span}
                                                        onClick={isClickable ? handleClick : undefined}
                                                        className={`${cellStyle}`}
                                                    >
                                                        {isClickable && (prefix === "SEQ" || prefix === "DETAIL") ? 
                                                            <div className='detail_icon'>
                                                                <span className='icon'><Theme.Search16 className='co_black'/></span>
                                                                <span className='hover_icon'>{SearchIcon}</span>
                                                                <span>보기</span>
                                                            </div>
                                                        : item[col]}
                                                    </td>
                                                );
                                            })}
                                        </tr>
                                        )
                                    })
                                )}
                            </tbody>
                        </table>
                    </div>
                    <hr className='mr-1-1 co_border_gray' />
                    {dataList.length === 0 || !paginationTF ? (
                        <br />
                    ) : (
                        <Pagination
                            paginationInfo={paginationInfo}
                        />
                    )}
                </>
            }
        </div>
    );
};

export default ShowDetailDataGrid;